import { render, staticRenderFns } from "./canteenMain.vue?vue&type=template&id=4375a098&scoped=true"
import script from "./canteenMain.vue?vue&type=script&lang=js"
export * from "./canteenMain.vue?vue&type=script&lang=js"
import style0 from "./canteenMain.vue?vue&type=style&index=0&id=4375a098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4375a098",
  null
  
)

export default component.exports